(function () {
  "use strict";

  var yapaSyncing = false;
  var yapaQueued = false;
  var yapaRefreshAfterSync = false;

  function getYapaConfig() {
    var node = document.querySelector("[data-ecofrit-yapa-config]");
    if (!node) return null;
    try {
      var config = JSON.parse(node.textContent || "{}");
      return config.giftVariantId ? config : null;
    } catch (error) {
      return null;
    }
  }

  function yapaUnitsForItem(item) {
    if (!item || !item.handle) return 0;
    if (item.handle === "pack-x10-ecofrit") return item.quantity;
    if (item.handle === "pack-x5-ecofrit" || item.handle === "pack-x5-ecofrit-copia") {
      return item.quantity;
    }
    return 0;
  }

  function requestCartRefresh() {
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
  }

  function updateCampaignCartCount(itemCount) {
    document.querySelectorAll(".campaign-header [data-cart-items-qty]").forEach(function (badge) {
      badge.textContent = String(itemCount);
      badge.classList.toggle("hidden", itemCount === 0);
    });
  }

  function syncYapa(refreshDrawer) {
    var config = getYapaConfig();
    if (!config) return Promise.resolve(false);

    if (yapaSyncing) {
      yapaQueued = true;
      yapaRefreshAfterSync = yapaRefreshAfterSync || !!refreshDrawer;
      return Promise.resolve(false);
    }

    yapaSyncing = true;
    yapaRefreshAfterSync = yapaRefreshAfterSync || !!refreshDrawer;

    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart.js", {
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("No se pudo leer el carrito");
        return response.json();
      })
      .then(function (cart) {
        updateCampaignCartCount(cart.item_count || 0);
        var desiredQuantity = 0;
        var giftLines = [];

        cart.items.forEach(function (item) {
          var isAutomaticGift = item.properties && item.properties._ecofrit_yapa === "septiembre-2026";
          if (isAutomaticGift) {
            giftLines.push(item);
          } else {
            desiredQuantity += yapaUnitsForItem(item);
          }
        });

        if (giftLines.length === 0 && desiredQuantity === 0) {
          return false;
        }

        if (giftLines.length === 1 && giftLines[0].quantity === desiredQuantity) {
          return false;
        }

        if (giftLines.length === 0 && desiredQuantity > 0) {
          return fetch(window.theme.routes.cart_add_url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{
                id: Number(config.giftVariantId),
                quantity: desiredQuantity,
                properties: { _ecofrit_yapa: "septiembre-2026" },
              }],
            }),
          }).then(function (response) {
            if (!response.ok) throw new Error("No se pudo agregar la Yapa");
            return true;
          });
        }

        var updates = {};
        giftLines.forEach(function (item, index) {
          updates[item.key] = index === 0 ? desiredQuantity : 0;
        });

        return fetch(window.theme.routes.cart_update_url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          if (!response.ok) throw new Error("No se pudo actualizar la Yapa");
          return true;
        });
      })
      .then(function (changed) {
        if (changed && yapaRefreshAfterSync) requestCartRefresh();
        return changed;
      })
      .catch(function (error) {
        console.warn("Ecofrit Yapa:", error.message);
        return false;
      })
      .finally(function () {
        var runAgain = yapaQueued;
        var refreshAgain = yapaRefreshAfterSync;
        yapaSyncing = false;
        yapaQueued = false;
        yapaRefreshAfterSync = false;
        if (runAgain) window.setTimeout(function () { syncYapa(refreshAgain); }, 80);
      });
  }

  document.addEventListener("theme:cart:added", function () {
    window.setTimeout(function () { syncYapa(true); }, 80);
  });

  document.addEventListener("theme:cart:loaded", function () {
    window.setTimeout(function () { syncYapa(true); }, 80);
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-ecofrit-cart-upgrade]");
    if (!button) return;

    event.preventDefault();
    button.disabled = true;
    button.textContent = "Cambiando…";

    fetch(window.theme.routes.cart_change_url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: button.dataset.removeKey, quantity: 0 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("No se pudo quitar el pack anterior");
        return fetch(window.theme.routes.cart_add_url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error("No se pudo agregar el nuevo pack");
        window.sessionStorage.setItem("ecofrit-open-cart", "true");
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = "Intentar de nuevo";
      });
  });

  window.addEventListener("DOMContentLoaded", function () {
    syncYapa(true);
    if (window.sessionStorage.getItem("ecofrit-open-cart") !== "true") return;
    window.sessionStorage.removeItem("ecofrit-open-cart");
    var toggle = document.querySelector("[data-cart-drawer-toggle]");
    if (toggle) window.setTimeout(function () { toggle.click(); }, 250);
  });
})();
